export default __webpack_public_path__ + "static/media/e1.3d4c3689.png";